import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

export type TGeneratorHeaderSaveConfig = {
    onSave: () => void;
    visible: boolean;
};

type TGeneratorHeaderSaveContextValue = {
    config: TGeneratorHeaderSaveConfig | null;
    setSaveConfig: (config: TGeneratorHeaderSaveConfig | null) => void;
};

const GeneratorHeaderSaveContext = createContext<TGeneratorHeaderSaveContextValue | null>(null);

export const GeneratorHeaderSaveProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [config, setConfig] = useState<TGeneratorHeaderSaveConfig | null>(null);

    const setSaveConfig = useCallback((next: TGeneratorHeaderSaveConfig | null) => {
        setConfig(next);
    }, []);

    const value = useMemo(
        () => ({ config, setSaveConfig }),
        [config, setSaveConfig]
    );

    return (
        <GeneratorHeaderSaveContext.Provider value={value}>{children}</GeneratorHeaderSaveContext.Provider>
    );
};

export function useGeneratorHeaderSaveConfig(): TGeneratorHeaderSaveConfig | null {
    return useContext(GeneratorHeaderSaveContext)?.config ?? null;
}

/** Ustawia przycisk zapisu w nagłówku; poza providerem — no-op. */
export function useGeneratorHeaderSaveRegister(): (
    config: TGeneratorHeaderSaveConfig | null
) => void {
    const setSaveConfig = useContext(GeneratorHeaderSaveContext)?.setSaveConfig;
    return setSaveConfig ?? (() => {});
}
